export enum PhotoCaptureErrorName {
  MISSING_TASK_IN_INSPECTION = 'PhotoCaptureMissingTaskInInspection',
}
